import template from '../../../../../../Template/config/components/scorecard/ScorecardView/ScorecardStatTesting'
export default {
  ...template,
  thresholdConstant: 1.96,
  labels: [
    {
      high: {
        color: '#d8e4bc',
        // color: '#89C35F',
        text: 'Significantly above the norm at 95%'
      },
      low: {
        color: '#f2dcdb',
        // color: '#F9A23B',
        text: 'Significantly below the norm at 95%'
      }
    }
  ],
}



// WEBPACK FOOTER //
// ./src/app/configuration/Optimum/config/components/scorecard/ScorecardView/ScorecardStatTesting/index.js